import { render, staticRenderFns } from "./ViewPatientNotes.vue?vue&type=template&id=b132b680"
import script from "./ViewPatientNotes.vue?vue&type=script&lang=js"
export * from "./ViewPatientNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports